import type { TypeExpense } from '@/types/expense/types.expense';
import type { TypeExpenseSort } from '@/types/expense/types.expense.query';

const DUE_LAST = '9999-12-31';

const normalize = (value: string): string => String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const dueKey = (expense: TypeExpense): string => (expense.stage === 'planned' ? expense.plannedDate : expense.dueDate) || DUE_LAST;

const text = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);
const number = (a: number, b: number): number => a - b;

const FIELDS: Record<TypeExpenseSort, ((a: TypeExpense, b: TypeExpense) => number)[]> = {
    date: [(a, b) => -text(a.documentDate, b.documentDate)],
    amount: [(a, b) => -number(a.totalCents, b.totalCents)],
    supplier: [(a, b) => text(normalize(a.supplierName), normalize(b.supplierName))],
    due: [(a, b) => text(dueKey(a), dueKey(b))],
    number: [(a, b) => -number(a.number.year, b.number.year), (a, b) => -number(a.number.seq, b.number.seq)],
    updated: [(a, b) => -text(a.updatedAt, b.updatedAt)],
};

export function expenseQueryOrder(sort: TypeExpenseSort, reverse: boolean): (a: TypeExpense, b: TypeExpense) => number {
    const steps = [...(FIELDS[sort] ?? FIELDS.date), (a: TypeExpense, b: TypeExpense) => text(a.id, b.id)];
    const sign = reverse ? -1 : 1;
    return (a, b) => {
        for (const step of steps) {
            const result = step(a, b);
            if (result !== 0) return sign * result;
        }
        return 0;
    };
}

export default expenseQueryOrder;
